// extracted by mini-css-extract-plugin
module.exports = {"Switch":"switch_Switch__MJGg_","Thumb":"switch_Thumb__QXIKm","Label":"switch_Label__Q6Dpu"};